import {
  BadgeDollarSign,
  Brain,
  ChartColumn,
  FileText,
  Globe2,
  HelpCircle,
  Image,
  KeyRound,
  LayoutDashboard,
  Lightbulb,
  Link2,
  Megaphone,
  Newspaper,
  PenLine,
  Play,
  Plug,
  Activity,
  Bell,
  Radar,
  Search,
  Settings,
  Share2,
  Sparkles,
  User,
  Video,
  Workflow,
  type LucideIcon,
} from "lucide-react";
import type { NavDef } from "@/config/navigation";

export const NAV_ICONS: Record<NavDef["icon"], LucideIcon> = {
  layout: LayoutDashboard,
  brain: Brain,
  radar: Radar,
  search: Search,
  key: KeyRound,
  newspaper: Newspaper,
  fileText: FileText,
  pen: PenLine,
  share: Share2,
  megaphone: Megaphone,
  badge: BadgeDollarSign,
  image: Image,
  video: Video,
  // Fallback glyph only: the Sidebar renders the official YouTube brand mark
  // (shipped asset) for items that declare `brandIcon: "youtube"`.
  youtube: Play,
  globe: Globe2,
  link: Link2,
  sparkles: Sparkles,
  chart: ChartColumn,
  lightbulb: Lightbulb,
  workflow: Workflow,
  plug: Plug,
  activity: Activity,
  bell: Bell,
  settings: Settings,
  user: User,
  help: HelpCircle,
};
